import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../common';

import config from '../../utils/config';
import request from '../../utils/request';

interface IProps {
    type ? : number,
        styleConfig ? : object
}

export default class TopNav extends React.Component < IProps, any > {
    constructor(props: any) {
        super(props);
        this.state = {
            showTopone: false,
            isSwitch: false, // 是否切换 true为切换
            pathName: '',
            isMiniBaiduProgram: (window as any).isMiniBaiduProgram, // 是否在百度小程序中
            shopId: '', // 店铺id
            shopDomain: '', // 店铺域名
            infoData: {},
            modelsId: '', // 模板id
            styleConfig: {},
            styleShow: false,
        };
    }

    public componentWillMount() {
        this._getId();
    }

    public componentDidMount() {
        // 头部面板控制
        const path: any[] = window.location.pathname.split('/');
        const btn = false; // 面板按钮

        if (path.length > 1) {
            this.setState({
                isSwitch: btn,
                pathName: path[path.length - 2],
            });

            switch (path[path.length - 2]) {
                case 'courses':
                case 'experts':
                case 'datasheet':

                    this.setState({
                        isSwitch: true,
                        pathName: path[path.length - 2],
                    });

                    break;
                default:
                    return;
            }

        }


    }

    public componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    }

    public render() {
        return (
            <div className="footer">
                <div className="Footed" style={{display: this.state.styleShow ? 'block' : 'none', backgroundColor: `${ this.state.styleConfig ? ((this.state.styleConfig as any).wap_bottom_back || '') : ''}` }}>
                        <ul>
                            <li className="Fcur" >
                                <a onClick={() => this._push('/m/classify') } style={{color: this.getColor()}}>
                                    <img src={this.state.styleConfig.wap_tacitly_icon} />
                                    <p>商品分类</p>
                                </a>
                            </li>
                            {
                                this.state.infoData.seller_grade !== '1' ?
                                <li className="Fcur2">
                                    <a onClick={() => this._push('/m/offerlist') } style={{color: this.getColor()}}>
                                        <img src={this.state.styleConfig.wap_supply_icon} />
                                        <p>供应商品</p>
                                    </a>
                                </li> : null
                            }
                            {
                                this.state.showTopone && <li className="Fcur3">
                                <a onClick={() => this._push('/m/topone') } style={{color: this.getColor()}}>
                                    <img src={this.state.styleConfig.wap_treasure_icon} />
                                    <p>镇店之宝</p>
                                </a>
                            </li>
                            }
                            <li className="Fcur4">
                                <a onClick={() => this._push('/m/datasheet') } style={{color: this.getColor()}}>
                                    <img src={this.state.styleConfig.wap_u_icon} />
                                    <p>优料库</p>
                                </a>
                            </li>
                        </ul>
                </div>
            </div>

        )
    }

    private getQueryString(name: string) {
        const reg = new RegExp("(^|/?|&)" + name + "=([^&]*)(&|$)", "i");
        const r = decodeURIComponent(location.href).substr(1).match(reg);
        if (r != null) {
            return r[2]
        };
        return null;
    }

    // 获取样式
    private async _getStyle() {
        const r = request({
            url: config.PHPAPI + 'api/wshop/shop/get-models',
            method: 'post',
            data: {
                shopId: this.state.shopId,
                shopDomain: this.state.shopDomain,
                modelsId: this.state.modelsId,
            }
        })

        r.then(res => {
            if (res.error_code === 0) {
                this.setState({
                    styleConfig: res.data.wap_configuration,
                    styleShow: true,
                });
            }
        })
    }

    // 获取企业id
    private async _getId() {
        const path: any = (window as any).shopId;

        const r = request({
            data: {
                shopDomain: path,
            },
            method: 'post',
            url: config.PHPAPI + 'api/wshop/shop/shop-info',
        })

        r.then(res => {
            if (res.error_code === 0) {
                document.title = res.data[0].shop_name;

                this.setState({
                    shopId: res.data[0].shop_id || '',
                    modelsId: this.getQueryString('modelsId') || res.data[0].models_id,
                    shopDomain: res.data[0].shop_domain || '',
                    infoData: res.data[0],
                }, () => {
                    this._getStyle();
                    this.getTreasureInfo();
                });
            }
        })
    }
    // 获取颜色
    private getColor() {
        if (this.state.styleConfig && (this.state.styleConfig as any).wap_bottom_font) {
            return (this.state.styleConfig as any).wap_bottom_font;
        }

        return ''
    }

    private _push(url: string) {
        window.location.href = url + '/';
    }

    private async getTreasureInfo() {
        const r = await request({
            data: {
                shopId: this.state.shopId
            },
            method: 'get',
            url: config.PHPAPI + 'api/shop/goods/get-treasure',
        })

        if (r.error_code === 0) {
            if (r.data.treasure) {
                this.setState({
                    showTopone: true
                })
            }
            return
        }


    }
}

ReactDOM.render(
    <TopNav />,
    document.getElementById('root') as HTMLElement
);


// WEBPACK FOOTER //
// ./src/components/TopNav/index.tsx